import request from "../../../../utils/api";

//UPDATE cis info
export const updateCisInfo = params => {
  return request(`v1/sellers/customer-360/e-booking/update-cis/${params.id}`, {
    method: "put",
    body: params
  });
};
//UPDATE attachment
export const updateAttachment = params => {
  return request("v1/sellers/customer-360/e-booking/attachment", {
    method: "post",
    body: params
  });
};
//get reservation list from sap
export const getReservationListFromSap = params => {
  return request("v1/sellers/e-reservations", {
    body: params
  });
};
//search spouse
export const searchForSpouse = params => {
  return request("v1/sellers/customer-360/e-booking/spouse", {
    method: "post",
    params
  });
};
//search co buyer
export const searchForCoBuyer = params => {
  return request("v1/sellers/customer-360/e-booking/co-buyer", {
    method: "post",
    params
  });
};
//search group
export const searchForGroup = params => {
  return request("v1/sellers/customer-360/e-booking/searchGroupType", {
    method: "post",
    params
  });
};
//post buyer
export const postBuyer = params => {
  return request("v1/sellers/customer-360/e-booking/buyer", {
    method: "post",
    body: params
  });
};
//post spouse
export const postSpouse = params => {
  return request("v1/sellers/customer-360/e-booking/postSpouse", {
    method: "post",
    body: params
  });
};
//post co buyer
export const postCoBuyer = params => {
  return request("v1/sellers/customer-360/e-booking/postCoBuyer", {
    method: "post",
    body: params
  });
};
//post cis requirements
export const postCISRequirements = params => {
  return request("v1/sellers/customer-360/e-booking/cisRequirements", {
    method: "post",
    body: params
  });
};
//post cpra requirements
export const postCPRARequirements = params => {
  return request("v1/sellers/customer-360/e-booking/cpraRequirements", {
    method: "post",
    body: params
  });
};
//post purchase journey
export const postPurchaseJourney = params => {
  return request("v1/sellers/customer-360/e-booking/purchaseJourney", {
    method: "post",
    body: params
  });
};
//get reservation details
export const getReservationDetails = params => {
  return request(`v1/sellers/e-reservations/details/${params}`, {
    params
  });
};
//maintained values
export const getMaintainedValues = params => {
  return request("v1/mv", {
    body: params
  });
};
//get draft user values
export const getDraftUser = params => {
  return request("v1/sellers/customer-360/e-booking/getDraftUser", {
    body: params
  });
};
//submit to sap
export const submitToSap = params => {
  return request("v1/sellers/customer-360/e-booking/getBookingList", {
    method: "post",
    body: params
  });
};